module.exports = __webpack_public_path__ + "img/money-check-dollar.188475fe.svg";